module.exports = __webpack_public_path__ + "static/media/man-checking-list-img.aeb88000.png";